import { MessageCircle, Sun, Wind, HandHeart, Clock, Compass } from "lucide-react";

const items = [
  { icon: MessageCircle, title: "Expresar sin filtros", text: "Un espacio para nombrar cómo te sientes, sin juicios." },
  { icon: Sun, title: "Recuperar claridad y calma", text: "Pequeños descansos mentales en mitad del día." },
  { icon: Wind, title: "Gestionar estrés y frustración", text: "Herramientas concretas, no consejos genéricos." },
  { icon: HandHeart, title: "Sentirse acompañado", text: "Un apoyo discreto, justo cuando hace falta." },
  { icon: Clock, title: "Ayuda en el momento exacto", text: "No al final del trimestre. Ahora." },
  { icon: Compass, title: "Volver al control emocional", text: "Recuperar foco para seguir trabajando bien." },
];

export function EmployeeBenefits() {
  return (
    <section className="relative bg-surface py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Herramientas reales <br className="hidden sm:block" />
            para <span className="text-gradient-brand">momentos reales.</span>
          </h2>
        </div>
        <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {items.map((it) => (
            <div key={it.title} className="rounded-3xl border border-border bg-card p-7 shadow-soft transition hover:-translate-y-1">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl gradient-soft">
                <it.icon className="h-5 w-5 text-primary" strokeWidth={2} />
              </span>
              <h3 className="mt-5 text-lg font-semibold text-foreground">{it.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
